import React, { useState, useContext, useEffect } from "react";
import { Redirect } from "react-router-dom";
import logo from "./../images/EDVES-LOGO 2.png";
import PageSubTitle from "../components/common/PageSubTitle";
import Button from "../components/common/Button";
import Card from "../components/common/Card";
import Label from "../components/common/Label";
import Lessons from "../components/common/Lessons";
import Modal from "../components/common/Modal";
import FormInput from "../components/FormInput";
import { Form, Formik } from "formik";
import FormSuccess from "../components/common/FormSuccess";
import FormError from "../components/common/FormError";
import * as Yup from "yup";
import classNames from "classnames";
import { Link } from "react-router-dom";
import schoolBag from "../images/schoolBag.png";
import HamburgerSvg from "../svg/HamburgerSvg";
import { publicFetch } from "./../util/fetch";
import { AuthContext } from "../context/AuthContext";
import axios from "axios";
import RecoveryPswrdModal from "./RecoveryPswrdModal";
import { toTitleCase } from "../util/titleCase";

import { BASEURL } from "../config";
import { DataContext } from "../context/DataContext";
import { animated, useSpring } from "react-spring";
import { AnimateSharedLayout } from "framer-motion";

const LoginSchema = Yup.object().shape({
  admissionnumber: Yup.string().required("Admission number is required"),
  password: Yup.string().required("Password is required"),
});

const RecoveryCodeSchema = Yup.object().shape({
  recoverycode: Yup.string().required("Recovery Code is required"),
  password: Yup.string().required("Please inpute new password"),
  confirmpassword: Yup.string().required(
    "Please input the new password again "
  ),
});

const lessons = ["Subject", "Subject", "Subject", "Subject", "Subject"];

const showModalStyling = classNames({
  "border-0 rounded-lg shadow-lg w-10/12 sm:w-7/12 p-5 sm:p-8 relative flex flex-col mx-auto bg-white outline-none focus:outline-none": true,
});

const RecoveryCodeModalStyling = classNames({
  "border-0 rounded-lg shadow-lg mx-auto w-10/12 sm:w-full p-5 sm:p-8 relative flex flex-col bg-white outline-none focus:outline-none": true,
});

const PwrdTitle = () => (
  <span className='text-gray-100'> Reset your password </span>
);

const RecoveryTitle = () => (
  <span className='text-green-100'> Recovery code sent </span>
);

const Login = () => {
  const authContext = useContext(AuthContext);
  const dataContext = useContext(DataContext);

  // const schoolName = authContext.schoolInfo.schoolName;
  const subSchoolData = JSON.parse(localStorage.getItem("subSchoolData"));
  const schoolName = subSchoolData.name;
  const schoolLogo = subSchoolData.school_logo;

  const [showModal, setShowModal] = useState(false);
  const [loginLoading, setLoginLoading] = useState(false);
  const [recoveryPswrdSuccessMsg, setRecoveryPswrdSuccessMsg] = useState("");
  const [recoveryPswrdErrMsg, setRecoveryPswrdErrMsg] = useState("");
  const [recoveryCodeModal, setRecoveryCodeModal] = useState(false);
  const [recoveryPswrdLoading, setRecoveryPswrdLoading] = useState("");
  const [redirectOnLogin, setRedirectOnLogin] = useState(false);
  const [forgotPswrdAdmissionNum, setForgotPswrdAdmissionNum] = useState("");
  const [loginSuccess, setLoginSuccess] = useState();
  const [loginError, setLoginError] = useState();
  const [resetPwrdLoading, setResetPwrdLoading] = useState("");
  const [resetPswrdSuccessMsg, setResetPswrdSuccessMsg] = useState("");
  const [resetPswrdErrorMsg, setResetPswrdErrorMsg] = useState("");

  const schoolDomain = localStorage.getItem("schoolDomain");
  // const defaultSchoolName = JSON.parse(localStorage.getItem('schoolInfo').defaultSchoolName);

  const onSubmitForgotPwrd = async (credentials) => {
    console.log(credentials);
    const forgotPwrdCredentials = {
      admissionnumber: credentials,
      SchoolUrl: schoolDomain,
      deploymentIdx: subSchoolData.idx,
    };
    try {
      setRecoveryPswrdLoading(true);
      const { data } = await axios.post(
        `${BASEURL}/student/forgetpassword`,
        forgotPwrdCredentials
      );
      if (data.status) {
        setRecoveryPswrdLoading(false);
        // console.log('clicked submit password', data);
        setRecoveryPswrdSuccessMsg(data.message);
        authContext.setForgotPswrd(data.data);
        setTimeout(() => {
          setShowModal(false);
          setRecoveryCodeModal(true);
        }, 900);
      } else {
        setRecoveryPswrdErrMsg(data.message);
        setRecoveryPswrdLoading(false);
      }
      setForgotPswrdAdmissionNum(credentials);
    } catch (error) {
      console.log(error);
      setRecoveryPswrdErrMsg("Something went wrong");
    }
  };

  const resetMsgs = {
    recoveryPswrdErrMsg,
    recoveryPswrdSuccessMsg,
  };

  const ModalBody = () => {
    return (
      <>
        <div className='py-2'>
          <Formik
            initialValues={{
              admissionnumber: "",
            }}
            onSubmit={(values) => onSubmitForgotPwrd(values)}
            validationSchema={LoginSchema}>
            {() => (
              <Form className=''>
                {loginSuccess && <FormSuccess text={loginSuccess} />}
                {loginError && <FormError text={loginError} />}
                <div className='mb-2 w-full sm:w-3/4'>
                  <div className='mb-1'>
                    <Label text='Admission Number' />
                  </div>
                  <FormInput
                    ariaLabel='Admission Number'
                    name='admissionnumber'
                    type='text'
                  />
                </div>
                <span className='text-sm text-gray-400 leading-5'>
                  A recovery code would be sent to the phone number and email
                  address registered with the admission number provided
                </span>
                <div className='mt-6 w-36'>
                  <Button
                    type='submit'
                    text='Get recovery code'
                    // onClick={ handleRecoveryPword }
                  />
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </>
    );
  };

  const handleRecoveryPword = () => {
    setShowModal(false);
    setRecoveryCodeModal(true);
  };

  const handleSetPswrd = () => {
    setRecoveryCodeModal(false);
  };

  const recoveryCodeBtn = {
    text: "Set Password",
    onClick: handleSetPswrd,
  };

  const closeModal = () => {
    setShowModal(false);
    setRecoveryPswrdErrMsg("");
  };

  const closeRecoveryCodeModal = () => {
    setRecoveryCodeModal(false);
    setResetPswrdErrorMsg("");
    setResetPswrdSuccessMsg("");
  };

  const RecoveryCodeModalBody = () => {
    return (
      <>
        <div className='py-2 w-full'>
          <p className='text-gray-400 text-sm leading-5 my-2'>
            {" "}
            Check your phone/email for the recovery SMS{" "}
          </p>
          <Formik
            initialValues={{
              recoverycode: "",
              password: "",
              confirmpassword: "",
            }}
            onSubmit={onSubmitResetPwrd}
            validationSchema={RecoveryCodeSchema}>
            {() => (
              <Form className=''>
                {resetPswrdSuccessMsg && (
                  <FormSuccess text={resetPswrdSuccessMsg} />
                )}
                {resetPswrdErrorMsg && <FormError text={resetPswrdErrorMsg} />}
                <div className='mb-2 w-full sm:w-5/6'>
                  <div className='mb-1'>
                    <Label text='Recovery Code' />
                  </div>
                  <FormInput
                    ariaLabel='Recovery Code'
                    name='recoverycode'
                    type='text'
                  />
                </div>
                <div className='mb-2 w-full sm:w-5/6'>
                  <div className='mb-1'>
                    <Label text='New Password' />
                  </div>
                  <FormInput
                    ariaLabel='New Password'
                    name='password'
                    type='text'
                  />
                </div>
                <div className='mb-2 w-full sm:w-5/6'>
                  <div className='mb-1'>
                    <Label text='Confirm Password' />
                  </div>
                  <FormInput
                    ariaLabel='Confirm Password'
                    name='confirmpassword'
                    type='text'
                  />
                </div>
                <div className='mt-6 w-36'>
                  <Button
                    type='submit'
                    text='Set Password'
                    //onClick={handleRecoveryPword}
                    loading={resetPwrdLoading}
                  />
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </>
    );
  };

  const onSubmitResetPwrd = async (credentials) => {
    const fullResetCredentials = {
      recoverycode: credentials.recoverycode,
      password: credentials.password,
      confirmpassword: credentials.confirmpassword,
      SchoolUrl: schoolDomain,
      admissionnumber: forgotPswrdAdmissionNum,
    };

    try {
      setResetPwrdLoading(true);
      const { data } = await axios.post(
        "/student/resetpassword",
        fullResetCredentials
      );
      console.log(data);
      if (data.status) {
        setResetPwrdLoading(false);
        setResetPswrdSuccessMsg(data.message);
        setTimeout(() => {
          setRecoveryCodeModal(false);
        }, 1000);
        //setResetPswrdSuccessMsg('');
      } else {
        setResetPwrdLoading(false);
        setResetPswrdErrorMsg(data.message);
      }
    } catch (error) {
      console.log(error);
      setResetPwrdLoading(false);
      setResetPswrdErrorMsg("Something went wrong");
    }
  };

  const submitCredentials = async (credentials) => {
    const fullCredentials = {
      admissionnumber: credentials.admissionnumber,
      password: credentials.password,
      SchoolUrl: schoolDomain,
      deploymentidx: subSchoolData.idx,
    };
    console.log(fullCredentials);
    try {
      setLoginLoading(true);
      const { data } = await axios.post(
        `${authContext.baseUrl}/parentLogin`,
        fullCredentials
      );
      console.log(data, "new check");
      //   console.log(data.data);
      if (data.status) {
        authContext.setStudentInfo(data.data);

        localStorage.setItem(
          "studentList",
          JSON.stringify(data.data[0].otherChild)
        );
        setLoginSuccess(data.message);
        setLoginError("");
        // redirect after successful login
        setTimeout(() => {
          setRedirectOnLogin(true);
        }, 700);
      } else {
        setLoginError(toTitleCase(data.message));
        setLoginLoading(false);
      }
    } catch (error) {
      setLoginLoading(false);
      setLoginError("Something Went Wrong");
      console.log(error);
    }
  };

  const transitionStyles = useSpring({
    to: [{ opacity: 1, transform: "translateX(0px)" }],
    from: { opacity: 0, transform: "translateX(-100px)" },
    config: { duration: 500 },
  });

  return (
    <animated.div style={transitionStyles}>
      {redirectOnLogin && (
        <Redirect
          to={
            schoolDomain === "qcptaportal.edves.net" ? "/payments" : "/locker"
          }
        />
      )}
      <div className='bg-gray-700 h-screen'>
        <nav className='bg-white h-16 px-4 items-center flex justify-between'>
          <div className='sm:hidden'>
            <HamburgerSvg />
          </div>
          <img
            src={schoolLogo}
            alt='logo'
            className='w-12 object-cover cursor-pointer'
          />
          <span className='hidden sm:block sm:mx-auto text-gray-200 font-semibold text-sm leading-5'>
            {" "}
            {toTitleCase(schoolName)} Parents Portal{" "}
          </span>
        </nav>
        <div className='bg-blue-100 w-11/12 sm:w-3/5 mt-8 flex justify-between rounded-lg mx-auto px-6 py-4 items-center shadow-lg'>
          <div>
            <span className='text-sm sm:text-xl text-white leading-6 mt-1'>
              {" "}
              Welcome to{" "}
            </span>
            <p className='text-sm sm:text-base text-white font-bold leading-6 mt-1'>
              {" "}
              {toTitleCase(schoolName)}{" "}
            </p>
          </div>
          <div className='bagSize'>
            <img
              src={schoolBag}
              alt='login School Bag'
              className='w-full h-full'
            />
          </div>
        </div>
        {/* <div className="w-11/12 sm:w-2/3 flex justify-between mx-auto mt-8 mb-8">  sm:w-4/5 for form input*/}
        <div className='w-11/12 sm:w-3/5 flex justify-center mx-auto mt-8 mb-8'>
          <div className='w-full '>
            <Card>
              <div className='p-8'>
                <PageSubTitle
                  title={`Log in to view your child's academic records`}
                />
                <div className='w-3/4'>
                  <Formik
                    initialValues={{
                      admissionnumber: "",
                      password: "",
                    }}
                    onSubmit={(values) => submitCredentials(values)}
                    validationSchema={LoginSchema}>
                    {() => (
                      <Form className='mt-6'>
                        {loginSuccess && <FormSuccess text={loginSuccess} />}
                        {loginError && <FormError text={loginError} />}
                        <div>
                          <div className='mb-2'>
                            <div className='mb-1'>
                              <Label text='Admission Number' />
                            </div>
                            <FormInput
                              ariaLabel='Admission Number'
                              name='admissionnumber'
                              type='text'
                            />
                          </div>
                          <div>
                            <div className='mb-1'>
                              <Label text='Password' />
                            </div>
                            <FormInput
                              ariaLabel='Password'
                              name='password'
                              type='password'
                            />
                          </div>
                        </div>

                        <div className='mt-6 w-36'>
                          <Button
                            type='submit'
                            text='Log In'
                            loading={loginLoading}
                          />
                        </div>

                        <div className='mt-4 flex justify-start'>
                          <div
                            className='text-sm font-bold leading-5 hover:text-blue-300 cursor-pointer'
                            onClick={() => setShowModal(true)}>
                            Forgot password?
                          </div>
                        </div>
                      </Form>
                    )}
                  </Formik>
                </div>
              </div>
            </Card>
          </div>
          {/* <div className="hidden sm:block w-2/4 mb-4 p-2">
                        <Lessons to="resource-center" lessons={lessons} />
                    </div> */}
        </div>
        <div>
          {showModal && (
            <RecoveryPswrdModal
              closeModal={closeModal}
              Title={PwrdTitle}
              modalStyling={showModalStyling}
              BtnAttr={recoveryPswrdLoading}
              resetMsgs={resetMsgs}
              onSubmitForgotPwrd={onSubmitForgotPwrd}
            />
          )}
          {/* {showModal && <Modal closeModal={()=>setShowModal(false)} Title={PwrdTitle} modalStyling={showModalStyling} Body={ModalBody} BtnAttr={resetPswrdBtn} />} */}
        </div>
        <div>
          {recoveryCodeModal && (
            <Modal
              closeModal={closeRecoveryCodeModal}
              Title={RecoveryTitle}
              Body={RecoveryCodeModalBody}
              BtnAttr={recoveryCodeBtn}
              modalStyling={RecoveryCodeModalStyling}
            />
          )}
        </div>
      </div>
    </animated.div>
  );
};

export default Login;
